import { useState, useEffect } from 'react';
import { useAuth } from '@/context/AuthContext';
import { Redirect } from 'wouter';
import { supabaseAuth } from '@/lib/supabase-auth';

interface ProtectedRouteProps {
  children: React.ReactNode;
  redirectTo?: string;
  allowedUserTypes?: Array<'admin' | 'client'>;
  adminOnly?: boolean;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  redirectTo = '/area-clienti',
  allowedUserTypes,
  adminOnly = false
}) => {
  const [isChecking, setIsChecking] = useState(true);
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    const checkSession = () => {
      const session = supabaseAuth.getSession();
      setIsAdmin(!!session);
      setIsChecking(false);
    };

    checkSession();
  }, []);

  // 1. Admin Routes (Supabase Auth via localStorage)
  if (adminOnly) {
    if (isChecking) {
      return (
        <div className="min-h-screen bg-slate-950 flex items-center justify-center">
          <div className="text-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-teal-500 mx-auto mb-4"></div>
            <p className="text-white/70">Verifica autenticazione...</p>
          </div>
        </div>
      );
    }
    if (!isAdmin) {
      return <Redirect to="/supabase-admin-login" />;
    }
    return <>{children}</>;
  }

  // 2. Client Routes (Express Auth)
  const { isAuthenticated, user, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="min-h-screen bg-slate-950 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-teal-500 mx-auto mb-4"></div>
          <p className="text-white/70">Verifica autenticazione...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Redirect to={redirectTo} />;
  }

  if (allowedUserTypes && user && !allowedUserTypes.includes(user.userType)) {
    return <Redirect to={redirectTo} />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;